import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {SimpleListItem as RmwcSimpleListItem} from '@rmwc/list'
import {listItemStyles} from '../list-item'
import {listItemGraphicStyles} from '../list-item-graphic'
import '@rmwc/list/styles'

export const StyledRmwcSimpleListItem = styled(RmwcSimpleListItem)`
  ${listItemStyles}
  &&& .mdc-list-item__graphic {
    ${listItemGraphicStyles}
  }
`

const SimpleListItem = ({children, ...otherProps}) => <StyledRmwcSimpleListItem {...otherProps}>{children}</StyledRmwcSimpleListItem>

SimpleListItem.propTypes = {
  children: PropTypes.any
}

export {SimpleListItem}
